
import { createAsyncThunk } from "@reduxjs/toolkit";
import ApiBuilder, {
  OtpVerificationPayload,
  LoginPayload,
  SignUpPayload,
  SendVendorOTPpayload,
  VerifyVendorOTPpayload,
} from "@/api/ApiBuilder";
import { GenerateForgotPasswrodLinkForVendor,SignUpEmailVerificationPayload} from "@/types/interfaceType";



interface SignUpPayloadArg {
  payload: SignUpPayload; // Replace `any` with a proper interface if available
  callback?: (response: any) => void; // Optional callback
}

interface SignUpEmailVerificationPayloadArg {
  payload: SignUpEmailVerificationPayload; // Replace `any` with a proper interface if available
  callback?: (response: any) => void; // Optional callback
}


interface SendVendorOTPpayloadArg {
  payload: SendVendorOTPpayload;
  callback?: (response: any) => void; // Optional callback
}

interface VerifyVendorOTPpayloadArg {
  payload: VerifyVendorOTPpayload;
  callback?: (response: any) => void; // Optional callback
}


interface GenerateForgotPasswrodLinkForVendorArg {
  payload: GenerateForgotPasswrodLinkForVendor;
  callback?: (response: any) => void; // Optional callback
}

interface LoginArgs {
  credentials: LoginPayload; // Replace `any` with a proper interface if available
  callback?: (response: any) => void; // Optional callback
}


export const logout = createAsyncThunk(
  "auth/logout",
  async (_, { rejectWithValue }) => {
    try {
      sessionStorage.removeItem("bearer_token");
      return null;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const login = createAsyncThunk<any, LoginArgs>(
  "auth/login",
  async ({ credentials, callback }, { rejectWithValue }) => {
    try {
      const response = await ApiBuilder.login(credentials);
      if (callback) {
        callback(response)
      }
      return response;
    } catch (error) {
      const errorMessage =
        error?.error || error?.response?.data?.message || error?.message || "Login failed";

      return rejectWithValue(errorMessage);
    }
  }
);

export const sendVendorSignupOtpToEmail = createAsyncThunk<any, SignUpEmailVerificationPayloadArg>(
  "auth/sendVendorSignupOtpToEmail",
  async ({ payload, callback }, { rejectWithValue }) => {
    try {
      const response = await ApiBuilder.sendVendorSignupOtpToEmail(payload);
      if (callback) {
        callback(response)
      }
      return response;
    } catch (error) {
      const errorMessage = error?.error || error?.response?.data?.message || error?.message || "Signup failed";
      return rejectWithValue(errorMessage);
    }
  }
);


export const signUpVendor = createAsyncThunk<any, SignUpPayloadArg>(
  "auth/signUpVendor",
  async ({ payload, callback }, { rejectWithValue }) => {
    try {
      const response = await ApiBuilder.signUpVendor(payload);
      if (callback) {
        callback(response)
      }
      return response;
    } catch (error) {
      const errorMessage = error?.error || error?.response?.data?.message || error?.message || "Signup failed";
      return rejectWithValue(errorMessage);
    }
  }
);


export const sendVendorOTP = createAsyncThunk<any, SendVendorOTPpayloadArg>(
  "auth/sendVendorOTP",
  async ({ payload, callback }, { rejectWithValue }) => {
    try {
      const response = await ApiBuilder.sendVendorOTP(payload);
      if (callback) {
        callback(response)
      }
      return response;
    } catch (error) {
      const errorMessage = error?.error || error?.response?.data?.message || error?.message || "OTP Send failed";
      return rejectWithValue(errorMessage);
    }
  }
);


export const verifyVendorOTP = createAsyncThunk<any, VerifyVendorOTPpayloadArg>(
  "auth/verifyVendorOTP",
  async ({ payload, callback }, { rejectWithValue }) => {
    try {
      const response = await ApiBuilder.verifyVendorOTP(payload);
      if (callback) {
        callback(response)
      }
      return response;
    } catch (error) {
      const errorMessage = error?.error || error?.response?.data?.message || error?.message || "OTP verify failed";
      return rejectWithValue(errorMessage);
    }
  }
);


export const generateForgotPasswrodLinkForVendor = createAsyncThunk<any, GenerateForgotPasswrodLinkForVendorArg>(
  "auth/generateForgotPasswrodLinkForVendor",
  async ({ payload, callback }, { rejectWithValue }) => {
    try {
      const response = await ApiBuilder.generateForgotPasswrodLinkForVendor(payload);
      if (callback) {
        callback(response)
      }
      return response;
    } catch (error) {
      const errorMessage = error?.error || error?.response?.data?.message || error?.message || "Link generation failed";
      return rejectWithValue(errorMessage);
    }
  }
);



